import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdatePoints = (params) => {
    return axios.post(`${backendHost}/api/admin/tournament/update/points`, params);
};

export {
    postUpdatePoints
}